import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import ExploreTripsLHS from "./ExploreTripComponents/ExploreTripsLHSContent";
import { TripOverviewMap } from "./ExploreTripComponents/ExploreTripsRHSContent";
import { PopularTrip } from "@/types/trip";
import { socialService } from "@/services/socialService";
import logger from "@/utils/logger";

const TripsStructure: React.FC = () => {
  const [selectedTrip, setSelectedTrip] = useState<PopularTrip | null>(null);

  const {
    data: trips,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["explore-trips"],
    queryFn: () => socialService.getExplorePageTrips(),
  });

  useEffect(() => {
    if (trips?.data && trips.data.length > 0 && !selectedTrip) {
      const firstTrip = trips.data[0];
      if (firstTrip) {
        setSelectedTrip(firstTrip);
      }
    }
  }, [trips]);

  const handleTripSelect = (trip: PopularTrip) => {
    logger.log("Selected trip:", trip);
    setSelectedTrip(trip);
  };

  return (
    <div
      className="flex flex-col w-full"
      style={{ height: "calc(100vh - 120px)" }}
    >
      <div className="flex flex-row gap-4 flex-grow">
        <ExploreTripsLHS
          onTripSelect={handleTripSelect}
          trips={trips}
          isLoading={isLoading}
          error={error as Error | null}
          selectedTripId={selectedTrip?.trip_id}
        />
        <TripOverviewMap trip={selectedTrip} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default TripsStructure;
